import "./style.scss";
import Tabs from "@/src/components/Tabs/Tabs";
import {
  universityProgramsTabs,
  universityProgramsBachelor,
  universityProgramsMasters,
  universityProgramsDoctorate,
  universityProgramsCourses,
} from "@/src/constants/university-programs";
import { useState } from "react";
import UniversityProgramsCardsMob from "./UniversityProgramsCardsMob/UniversityProgramsCardsMob";

const UniversityProgramsMob = () => {
  const [currentTab, setCurrentTab] = useState<string>("bachelor");

  return (
    <div className="university-programs-mob container">
      <div className="university-programs-mob-header">
        <Tabs title="University Programs" tabs={universityProgramsTabs} currentTab={currentTab} setCurrentTab={setCurrentTab} />
      </div>
      {currentTab === "bachelor" && <UniversityProgramsCardsMob content={universityProgramsBachelor} currentTab={currentTab} />}
      {currentTab === "masters" && <UniversityProgramsCardsMob content={universityProgramsMasters} currentTab={currentTab} />}
      {currentTab === "doctorate" && <UniversityProgramsCardsMob content={universityProgramsDoctorate} currentTab={currentTab} />}
      {currentTab === "courses" && <UniversityProgramsCardsMob content={universityProgramsCourses} currentTab={currentTab} />}
    </div>
  );
};

export default UniversityProgramsMob;
